import React, { useEffect, useRef, useState, useContext } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";

function Addexregular12() {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const Navigate = useNavigate();
  const [enddate, setEnddate] = useState("");
  const { setCandidateid12, setMode12, setDivyangcode12, setCastecode12 } =
    useContext(ContextBoard);
  const [formData, setFormData] = useState({
    passingYear: "2025",
    session: "",
    reg1: "",
    reg2: "",
    reg3: "",
    registration_number4: "",
  });
  const reg2Ref = useRef(null);
  const reg3Ref = useRef(null);
  const token = sessionStorage.getItem("tokenclassxii");
  useEffect(() => {
    setCandidateid12("");
    setDivyangcode12("");
    setCastecode12("");
    setMode12("");
    const fetchSessions = async () => {
      try {
        const schoolCode = sessionStorage.getItem("schoolCode");

        const res = await fetch(
          `${config.API_BASE_URL}/PageloadRegistrationSessionEXRegular_CL12?type=E`,
          {
            method: "GET",

            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({ schoolCode }),
          }
        );

        if (!res.ok) {
          throw new Error("Failed to fetch sessions");
        }

        const data = await res.json();
        setEnddate(
          data.data.sessionExRegular_data.registrationEndDate.registratioN_END
        );
        setSessions(data.data.sessionExRegular_data.sessionlist);
      } catch (error) {
        console.error("Error fetching sessions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, []);

  const handleChange = (e) => {
    // debugger;
    const { name, value } = e.target;
    // const numericValue = value.replace(/\D/g, "");

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Auto-focus forward
    if (name === "reg1" && value.length === 5) {
      reg2Ref.current.focus();
    }
    if (name === "reg2" && value.length === 4) {
      reg3Ref.current.focus();
    }
  };

  const handleBackspace = (e, fieldName) => {
    if (e.key === "Backspace" && formData[fieldName] === "") {
      if (fieldName === "reg3") {
        reg2Ref.current.focus();
      } else if (fieldName === "reg2") {
        document.querySelector("input[name='reg1']").focus();
      }
    }
  };

  const handleValidate = async () => {
    const { session, reg1, reg2, reg3 } = formData;

    if (!session || !reg1 || !reg2 || !reg3) {
      return Swal.fire(
        "Missing Fields",
        "Please fill all required fields.",
        "warning"
      );
    }

    if (reg1.length !== 5 || reg2.length !== 4 || reg3.length !== 2) {
      return Swal.fire(
        "Invalid Registration",
        "Registration number must be 5 + 4 + 2 digits.",
        "error"
      );
    }

    try {
      const res = await fetch(
        `${config.API_BASE_URL}/FetchDataEXRegularStudent_CL12`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            sessioN_CODE: session,
            registratioN_NO: `${reg1}-${formData.registration_number4}-${reg2}-${reg3}`,
          }),
        }
      );

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Validation failed");
      }

      const result = await res.json();

      // Swal.fire("Success", "Student validated successfully.", "success").then(
      //   () => {
      navigate("/class-xii-add-ex-regular-info-jac", {
        state: { studentData: result.data.exRegularStudentCL12_data },
      });
      //   }
      // );
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", error.message, "error");
    }
  };
  return (
    <>
      <div class="container-scroller">
        <Navbar12 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header ">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Add Ex-Regular
                      Student (Student Registration Page for Board Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            Navigate("/class-xii-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Registration Details</h4>
                    </div>
                    <div class="card-body">
                      <div
                        class="row d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div class="col-md-10 py-3">
                          <div class="row">
                            <label class="col-md-3">
                              Registration Session :{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div class="col-md-8">
                              <select
                                className="form-select form-select-xs"
                                name="session"
                                value={formData.session}
                                onChange={handleChange}
                                required
                              >
                                <option value="">Select</option>
                                {loading ? (
                                  <option>Loading...</option>
                                ) : (
                                  sessions.map((session) => (
                                    <option
                                      key={session.sessioN_CODE}
                                      value={session.sessioN_CODE}
                                    >
                                      {session.sessioN_FULL_NAME}
                                    </option>
                                  ))
                                )}
                              </select>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">
                              Registration Number :{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div class="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                name="reg1"
                                value={formData.reg1}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                onKeyDown={(e) => handleBackspace(e, "reg1")}
                                maxLength="5"
                                inputMode="numeric"
                                pattern="[0-9]*"
                              />
                              <p>5 Digits Only</p>
                            </div>
                            <div class="col-md-2">
                              <select
                                id="registration_number4"
                                name="registration_number4"
                                className="form-control form-select form-control-xs"
                                value={formData.registration_number4} // <-- bind value
                                onChange={handleChange} // <-- use the same handler
                                required
                              >
                                <option value="">Select</option>
                                <option value="RS">RS</option>
                                <option value="RC">RC</option>
                                <option value="RA">RA</option>
                                <option value="PC">PC</option>
                                <option value="PA">PA</option>
                              </select>
                            </div>
                            <div class="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                name="reg2"
                                value={formData.reg2}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                onKeyDown={(e) => handleBackspace(e, "reg2")}
                                maxLength="4"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                ref={reg2Ref}
                              />
                              <p>4 Digits Only</p>
                            </div>
                            <div class="col-md-2">
                              <input
                                className="form-control form-control-xs"
                                name="reg3"
                                value={formData.reg3}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    handleChange(e);
                                  }
                                }}
                                onKeyDown={(e) => handleBackspace(e, "reg3")}
                                maxLength="2"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                ref={reg3Ref}
                              />
                              <p>2 Digits Only</p>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-3"></div>
                            <div className="col-md-offset-3 col-md-8">
                              <div className="row">
                                <div className="col-md-8">
                                  <button
                                    type="button"
                                    className="btn btn-block btn-xs proceed-btn"
                                    onClick={handleValidate}
                                    style={{
                                      fontSize: "16px",
                                      padding: "8px",
                                      backgroundColor: "#FF0000",
                                      color: "white",
                                      fontWeight: "600",
                                    }}
                                    id="validate"
                                  >
                                    CLICK HERE TO VALIDATE &amp; PROCEED
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Addexregular12;
